export default __webpack_public_path__ + "static/media/megane-gallery-6.f9be8b21.jpg";